// Copied from https://stackoverflow.com/questions/28336104/humanize-a-string-in-javascript

export default function humanize (str) {
  return str
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/^[a-z]/, function (m) { return m.toUpperCase() })
}
